export const AccountMergeDecisionType = {
    MERGED: 'MERGED',
    SEPARATE: 'SEPARATE'
};
export const FlowType = {
    INFLOW: 'INFLOW',
    OUTFLOW: 'OUTFLOW',
    BOTH: 'BOTH'
};
export const ContractType = {
    STANDARD: 'STANDARD',
    DEMO: 'DEMO',
    AMENDMENT: 'AMENDMENT'
};
export const CommercialActivationStatus = {
    SCHEDULED: 'SCHEDULED',
    PENDING: 'PENDING',
    ACTIVE: 'ACTIVE',
    FAILED: 'FAILED'
};
export const CommercialOptionCode = {
    F24_BULK_DOWNLOAD: 'F24_BULK_DOWNLOAD',
    API_ACCESS: 'API_ACCESS',
    SERVICES_PACKAGE: 'SERVICES_PACKAGE',
    WAREHOUSE: 'WAREHOUSE',
    WAREHOUSE_ADVANCED: 'WAREHOUSE_ADVANCED'
};
export const CommercialCapacityRequestStatus = {
    PENDING: 'PENDING',
    IN_REVIEW: 'IN_REVIEW',
    QUOTED: 'QUOTED',
    CONTRACT_CREATED: 'CONTRACT_CREATED',
    SIGNED: 'SIGNED',
    REJECTED: 'REJECTED',
    CANCELLED: 'CANCELLED'
};
export const ContractStatus = {
    DRAFT: 'DRAFT',
    SENT: 'SENT',
    VIEWED: 'VIEWED',
    SIGNED: 'SIGNED',
    EXPIRED: 'EXPIRED',
    CANCELED: 'CANCELED',
    DEMO_ACTIVE: 'DEMO_ACTIVE',
    DEMO_EXPIRED: 'DEMO_EXPIRED',
    CONVERTED: 'CONVERTED'
};
export const ContractEventType = {
    CREATED: 'CREATED',
    SENT: 'SENT',
    RESENT: 'RESENT',
    VIEWED: 'VIEWED',
    OTP_REQUESTED: 'OTP_REQUESTED',
    OTP_FAILED: 'OTP_FAILED',
    SIGNED: 'SIGNED',
    TENANT_CREATED: 'TENANT_CREATED',
    TENANT_CREATION_SKIPPED: 'TENANT_CREATION_SKIPPED',
    CANCELED: 'CANCELED',
    REOPENED: 'REOPENED',
    DATA_UPDATED: 'DATA_UPDATED',
    TENANT_UPGRADED: 'TENANT_UPGRADED',
    DEMO_CREATED: 'DEMO_CREATED',
    DEMO_EXTENDED: 'DEMO_EXTENDED',
    DEMO_EXPIRED: 'DEMO_EXPIRED',
    DEMO_CLEANED: 'DEMO_CLEANED',
    CONVERTED: 'CONVERTED',
    SHARED: 'SHARED'
};
export const CounterpartMaterialDirection = {
    GIVEN: 'GIVEN',
    RECEIVED: 'RECEIVED'
};
export const CounterpartMaterialReason = {
    LOAN: 'LOAN',
    SUBCONTRACTING: 'SUBCONTRACTING',
    REPAIR: 'REPAIR',
    RETURNABLE_PACKAGING: 'RETURNABLE_PACKAGING',
    APPROVAL: 'APPROVAL',
    OTHER: 'OTHER'
};
export const MachineStatus = {
    DRAFT: 'DRAFT',
    IN_SERVICE: 'IN_SERVICE',
    OUT_OF_SERVICE: 'OUT_OF_SERVICE',
    DECOMMISSIONED: 'DECOMMISSIONED'
};
export const MachineAssignmentKind = {
    INITIAL: 'INITIAL',
    TRANSFER: 'TRANSFER',
    RELOCATION: 'RELOCATION'
};
export const MachineCheckRecurrenceUnit = {
    DAY: 'DAY',
    MONTH: 'MONTH'
};
export const MachineCheckRecurrenceAnchor = {
    FIXED_CALENDAR: 'FIXED_CALENDAR',
    FROM_EXECUTION: 'FROM_EXECUTION'
};
export const MachineCheckPlanStatus = {
    ACTIVE: 'ACTIVE',
    SUSPENDED: 'SUSPENDED',
    TERMINATED: 'TERMINATED'
};
export const MachineCheckStatus = {
    DRAFT: 'DRAFT',
    SUBMITTED: 'SUBMITTED',
    APPROVED: 'APPROVED',
    CANCELLED: 'CANCELLED'
};
export const MachineCheckOutcome = {
    POSITIVE: 'POSITIVE',
    WITH_FINDINGS: 'WITH_FINDINGS',
    NEGATIVE: 'NEGATIVE',
    NOT_PERFORMED: 'NOT_PERFORMED'
};
export const MachineFindingSeverity = {
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    HIGH: 'HIGH',
    CRITICAL: 'CRITICAL'
};
export const MachineFindingStatus = {
    OPEN: 'OPEN',
    RESOLVED: 'RESOLVED'
};
export const MachineEventType = {
    CREATED: 'CREATED',
    UPDATED: 'UPDATED',
    ARCHIVED: 'ARCHIVED',
    RESTORED: 'RESTORED',
    DELETED: 'DELETED',
    TRANSFERRED: 'TRANSFERRED',
    RELOCATED: 'RELOCATED',
    COVERAGE_ADDED: 'COVERAGE_ADDED',
    COVERAGE_CLOSED: 'COVERAGE_CLOSED',
    COVERAGE_REMOVED: 'COVERAGE_REMOVED',
    PLAN_CREATED: 'PLAN_CREATED',
    PLAN_UPDATED: 'PLAN_UPDATED',
    PLAN_SUSPENDED: 'PLAN_SUSPENDED',
    PLAN_RESUMED: 'PLAN_RESUMED',
    PLAN_TERMINATED: 'PLAN_TERMINATED',
    CHECK_SUBMITTED: 'CHECK_SUBMITTED',
    CHECK_APPROVED: 'CHECK_APPROVED',
    CHECK_REOPENED: 'CHECK_REOPENED',
    CHECK_CANCELLED: 'CHECK_CANCELLED',
    CHECK_SIGNED: 'CHECK_SIGNED',
    CHECK_SIGNATURE_REMOVED: 'CHECK_SIGNATURE_REMOVED',
    FINDING_RESOLVED: 'FINDING_RESOLVED',
    IMPORTED: 'IMPORTED'
};
export const AccountType = {
    CASH: 'CASH',
    BANK: 'BANK',
    CREDIT_CARD: 'CREDIT_CARD',
    PRE_PAID: 'PRE_PAID',
    WALLET: 'WALLET',
    PAYPAL: 'PAYPAL',
    STRIPE: 'STRIPE',
    OTHER: 'OTHER'
};
export const AccountFieldSource = {
    NONE: 'NONE',
    BANK: 'BANK',
    MANUAL: 'MANUAL'
};
export const MovementType = {
    INFLOW: 'INFLOW',
    OUTFLOW: 'OUTFLOW',
    OPENING_BALANCE: 'OPENING_BALANCE',
    ADJUSTMENT: 'ADJUSTMENT'
};
export const CashMovementReconciliationState = {
    NONE: 'NONE',
    PARTIAL: 'PARTIAL',
    FULL: 'FULL'
};
export const CashMovementSplitSource = {
    MANUAL: 'MANUAL',
    DISTINTA_PARSER: 'DISTINTA_PARSER',
    IMPORT: 'IMPORT',
    ACCOUNT_TRANSFER: 'ACCOUNT_TRANSFER'
};
export const CompanyType = {
    BUSINESS: 'BUSINESS',
    INDIVIDUAL: 'INDIVIDUAL',
    PUBLIC_ADMINISTRATION: 'PUBLIC_ADMINISTRATION',
    OTHER: 'OTHER'
};
export const CompanyRole = {
    CUSTOMER: 'CUSTOMER',
    SUPPLIER: 'SUPPLIER',
    BOTH: 'BOTH'
};
export const RegimeFiscale = {
    RF01: 'RF01',
    RF02: 'RF02',
    RF04: 'RF04',
    RF05: 'RF05',
    RF06: 'RF06',
    RF07: 'RF07',
    RF08: 'RF08',
    RF09: 'RF09',
    RF10: 'RF10',
    RF11: 'RF11',
    RF12: 'RF12',
    RF13: 'RF13',
    RF14: 'RF14',
    RF15: 'RF15',
    RF16: 'RF16',
    RF17: 'RF17',
    RF18: 'RF18',
    RF19: 'RF19',
    RF20: 'RF20'
};
export const DocumentDirection = {
    OUTGOING: 'OUTGOING',
    INCOMING: 'INCOMING'
};
export const CashFlowDirection = {
    INFLOW: 'INFLOW',
    OUTFLOW: 'OUTFLOW'
};
export const TransportCare = {
    SENDER: 'SENDER',
    RECIPIENT: 'RECIPIENT',
    CARRIER: 'CARRIER'
};
export const TransportPort = {
    FRANCO: 'FRANCO',
    ASSEGNATO: 'ASSEGNATO'
};
export const IncomingInvoiceReviewStatus = {
    TO_VERIFY: 'TO_VERIFY',
    TO_APPROVE: 'TO_APPROVE',
    APPROVED: 'APPROVED'
};
export const DocumentStatus = {
    DRAFT: 'DRAFT',
    SENT: 'SENT',
    PAID: 'PAID',
    PARTIALLY_PAID: 'PARTIALLY_PAID',
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED',
    EXPIRED: 'EXPIRED',
    CONFIRMED: 'CONFIRMED',
    PARTIALLY_FULFILLED: 'PARTIALLY_FULFILLED',
    FULFILLED: 'FULFILLED',
    SHIPPED: 'SHIPPED',
    INVOICED: 'INVOICED',
    CANCELLED: 'CANCELLED',
    LOCKED: 'LOCKED'
};
export const DocumentType = {
    INVOICE: 'INVOICE',
    RECEIPT: 'RECEIPT',
    PAYROLL: 'PAYROLL',
    EXPENSE_REPORT: 'EXPENSE_REPORT',
    QUOTE: 'QUOTE',
    DELIVERY_NOTE: 'DELIVERY_NOTE',
    PROFORMA: 'PROFORMA',
    ORDER: 'ORDER',
    LOAN: 'LOAN',
    TAX_PAYMENT: 'TAX_PAYMENT',
    INPS_CONTRIBUTION: 'INPS_CONTRIBUTION',
    INAIL_PREMIUM: 'INAIL_PREMIUM',
    PA_DEBT: 'PA_DEBT'
};
export const DocumentSource = {
    MANUAL: 'MANUAL',
    JET_HR: 'JET_HR',
    CGN_F24: 'CGN_F24',
    ACUBE_CASSETTO: 'ACUBE_CASSETTO',
    ACUBE_SDI: 'ACUBE_SDI',
    XML_IMPORT: 'XML_IMPORT',
    GENYA_XLS: 'GENYA_XLS'
};
export const ElectronicDocumentType = {
    TD01: 'TD01',
    TD02: 'TD02',
    TD03: 'TD03',
    TD04: 'TD04',
    TD05: 'TD05',
    TD06: 'TD06',
    TD07: 'TD07',
    TD08: 'TD08',
    TD09: 'TD09',
    TD10: 'TD10',
    TD11: 'TD11',
    TD12: 'TD12',
    TD16: 'TD16',
    TD17: 'TD17',
    TD18: 'TD18',
    TD19: 'TD19',
    TD20: 'TD20',
    TD21: 'TD21',
    TD22: 'TD22',
    TD23: 'TD23',
    TD24: 'TD24',
    TD25: 'TD25',
    TD26: 'TD26',
    TD27: 'TD27',
    TD28: 'TD28',
    TD29: 'TD29'
};
export const VatExigibility = {
    IMMEDIATE: 'IMMEDIATE',
    DEFERRED: 'DEFERRED',
    SPLIT: 'SPLIT'
};
export const PaymentMethod = {
    MP01: 'MP01',
    MP02: 'MP02',
    MP03: 'MP03',
    MP04: 'MP04',
    MP05: 'MP05',
    MP06: 'MP06',
    MP07: 'MP07',
    MP08: 'MP08',
    MP09: 'MP09',
    MP10: 'MP10',
    MP11: 'MP11',
    MP12: 'MP12',
    MP13: 'MP13',
    MP14: 'MP14',
    MP15: 'MP15',
    MP16: 'MP16',
    MP17: 'MP17',
    MP18: 'MP18',
    MP19: 'MP19',
    MP20: 'MP20',
    MP21: 'MP21',
    MP22: 'MP22',
    MP23: 'MP23'
};
export const DistintaMovementLinkStatus = {
    SUGGESTED: 'SUGGESTED',
    CONFIRMED: 'CONFIRMED',
    REJECTED: 'REJECTED',
    IGNORED: 'IGNORED'
};
export const DistintaMovementRole = {
    COLLECTION_SETTLEMENT: 'COLLECTION_SETTLEMENT',
    ADVANCE_DISBURSEMENT: 'ADVANCE_DISBURSEMENT',
    GOOD_END_SETTLEMENT: 'GOOD_END_SETTLEMENT',
    INSOLUTO_RECLAIM: 'INSOLUTO_RECLAIM',
    INSOLUTO_FEES: 'INSOLUTO_FEES',
    ADVANCE_FEES: 'ADVANCE_FEES',
    CUSTOMER_SETTLEMENT: 'CUSTOMER_SETTLEMENT',
    GENERIC_BANK_LED: 'GENERIC_BANK_LED'
};
export const DistintaMovementSource = {
    DISTINTA_MATCH: 'DISTINTA_MATCH',
    BANK_LED: 'BANK_LED',
    MANUAL: 'MANUAL'
};
export const TransmissionFormat = {
    FPR12: 'FPR12',
    FPA12: 'FPA12',
    FSM10: 'FSM10'
};
export const TipoRitenuta = {
    RT01: 'RT01',
    RT02: 'RT02',
    RT03: 'RT03',
    RT04: 'RT04',
    RT05: 'RT05',
    RT06: 'RT06'
};
export const TipoCassa = {
    TC01: 'TC01',
    TC02: 'TC02',
    TC03: 'TC03',
    TC04: 'TC04',
    TC05: 'TC05',
    TC06: 'TC06',
    TC07: 'TC07',
    TC08: 'TC08',
    TC09: 'TC09',
    TC10: 'TC10',
    TC11: 'TC11',
    TC12: 'TC12',
    TC13: 'TC13',
    TC14: 'TC14',
    TC15: 'TC15',
    TC16: 'TC16',
    TC17: 'TC17',
    TC18: 'TC18',
    TC19: 'TC19',
    TC20: 'TC20',
    TC21: 'TC21',
    TC22: 'TC22'
};
export const CausalePagamento = {
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D',
    E: 'E',
    G: 'G',
    H: 'H',
    I: 'I',
    L: 'L',
    M: 'M',
    M1: 'M1',
    M2: 'M2',
    N: 'N',
    O: 'O',
    O1: 'O1',
    P: 'P',
    Q: 'Q',
    R: 'R',
    S: 'S',
    T: 'T',
    U: 'U',
    V: 'V',
    V1: 'V1',
    V2: 'V2',
    W: 'W',
    X: 'X',
    Y: 'Y',
    ZO: 'ZO'
};
export const CondizioniPagamento = {
    TP01: 'TP01',
    TP02: 'TP02',
    TP03: 'TP03'
};
export const ForecastStatus = {
    PLANNED: 'PLANNED',
    COMMITTED: 'COMMITTED',
    PARTIALLY_REALIZED: 'PARTIALLY_REALIZED',
    REALIZED: 'REALIZED',
    SKIPPED: 'SKIPPED',
    CANCELLED: 'CANCELLED'
};
export const ForecastScenarioType = {
    BASELINE: 'BASELINE',
    SIMULATION: 'SIMULATION'
};
export const RecurrenceFreq = {
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    QUARTERLY: 'QUARTERLY',
    SEMI_ANNUAL: 'SEMI_ANNUAL',
    YEARLY: 'YEARLY'
};
export const Weekday = {
    MO: 'MO',
    TU: 'TU',
    WE: 'WE',
    TH: 'TH',
    FR: 'FR',
    SA: 'SA',
    SU: 'SU'
};
export const SchedulePolicy = {
    EXACT_DAY: 'EXACT_DAY',
    PREV_BUSINESS_DAY: 'PREV_BUSINESS_DAY',
    NEXT_BUSINESS_DAY: 'NEXT_BUSINESS_DAY',
    LAST_DAY_OF_MONTH: 'LAST_DAY_OF_MONTH'
};
export const ReconciliationType = {
    OCCURRENCE_TO_DOCUMENT: 'OCCURRENCE_TO_DOCUMENT',
    SCHEDULE_TO_SCHEDULE: 'SCHEDULE_TO_SCHEDULE',
    SCHEDULE_TO_ALLOCATION: 'SCHEDULE_TO_ALLOCATION',
    FULL_MATCH: 'FULL_MATCH',
    PARTIAL_MATCH: 'PARTIAL_MATCH',
    VARIANCE: 'VARIANCE'
};
export const ReconciliationStatus = {
    PENDING: 'PENDING',
    PARTIALLY_MATCHED: 'PARTIALLY_MATCHED',
    FULLY_MATCHED: 'FULLY_MATCHED',
    VARIANCE: 'VARIANCE',
    SKIPPED: 'SKIPPED'
};
export const ScheduleSkipSource = {
    MANUAL: 'MANUAL',
    ONBOARDING: 'ONBOARDING',
    ERP_INBOUND: 'ERP_INBOUND',
    SCRIPT: 'SCRIPT',
    ACUBE_CASSETTO: 'ACUBE_CASSETTO'
};
export const ReconciliationLinkStatus = {
    PROPOSED: 'PROPOSED',
    CONFIRMED: 'CONFIRMED',
    REJECTED: 'REJECTED'
};
export const TypeOfPayment = {
    MANUAL: 'MANUAL',
    BANK_TRANSFER: 'BANK_TRANSFER',
    DIRECT_DEBIT: 'DIRECT_DEBIT',
    ONLINE: 'ONLINE'
};
export const CommercialUsageMetric = {
    INVOICE_SDI: 'INVOICE_SDI',
    TAX_DRAWER_DOCUMENT: 'TAX_DRAWER_DOCUMENT',
    F24_DOCUMENT: 'F24_DOCUMENT',
    BANK_CONNECTION: 'BANK_CONNECTION',
    TAX_DRAWER_CONNECTION: 'TAX_DRAWER_CONNECTION',
    USER: 'USER',
    TECHNICIAN: 'TECHNICIAN'
};
export const VatNature = {
    N1: 'N1',
    N2_1: 'N2_1',
    N2_2: 'N2_2',
    N3_1: 'N3_1',
    N3_2: 'N3_2',
    N3_3: 'N3_3',
    N3_4: 'N3_4',
    N3_5: 'N3_5',
    N3_6: 'N3_6',
    N3_7: 'N3_7',
    N4: 'N4',
    N5: 'N5',
    N6_1: 'N6_1',
    N6_2: 'N6_2',
    N6_3: 'N6_3',
    N6_4: 'N6_4',
    N6_5: 'N6_5',
    N6_6: 'N6_6',
    N6_7: 'N6_7',
    N6_8: 'N6_8',
    N6_9: 'N6_9',
    N7: 'N7'
};
export const PlanState = {
    ABORTED: 'ABORTED',
    ACTIVE: 'ACTIVE',
    COMPLETED: 'COMPLETED'
};
export const BillingPeriod = {
    MONTHLY: 'MONTHLY',
    ANNUAL: 'ANNUAL'
};
export const TenantQuotaScope = {
    SHARED: 'SHARED',
    OWN: 'OWN'
};
export const TenantRole = {
    OWNER: 'OWNER',
    ADMIN: 'ADMIN',
    USER: 'USER',
    GUEST: 'GUEST'
};
export const GlobalRole = {
    SUPERADMIN: 'SUPERADMIN',
    SYSTEM: 'SYSTEM',
    USER: 'USER',
    REFERRER: 'REFERRER'
};
export const TenantUserRelationship = {
    MEMBER: 'MEMBER',
    ADVISOR: 'ADVISOR'
};
export const AdvisorAccessEvent = {
    PANEL_VIEW: 'PANEL_VIEW',
    TENANT_OPEN: 'TENANT_OPEN'
};
export const SessionScope = {
    WEB: 'WEB',
    BACKOFFICE: 'BACKOFFICE'
};
export const ImportSource = {
    MANUAL: 'MANUAL',
    ACUBE: 'ACUBE',
    FABRICK: 'FABRICK',
    CSV_IMPORT: 'CSV_IMPORT',
    EXCEL_IMPORT: 'EXCEL_IMPORT',
    PDF_CARD_IMPORT: 'PDF_CARD_IMPORT',
    PDF_BANK_STATEMENT_IMPORT: 'PDF_BANK_STATEMENT_IMPORT',
    PAYPAL_CSV: 'PAYPAL_CSV',
    PAYPAL_API: 'PAYPAL_API'
};
export const OpenBankingProvider = {
    ACUBE: 'ACUBE',
    FABRICK: 'FABRICK',
    PAYPAL: 'PAYPAL'
};
export const OnboardingStatus = {
    PENDING: 'PENDING',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED'
};
export const ExchangeRateSource = {
    ECB: 'ECB',
    PROVIDER: 'PROVIDER',
    MANUAL: 'MANUAL',
    PAYPAL_CONVERSION: 'PAYPAL_CONVERSION'
};
export const BalanceSource = {
    API: 'API',
    CALCULATED: 'CALCULATED',
    MANUAL: 'MANUAL',
    CSV_ADJUSTED: 'CSV_ADJUSTED',
    DAILY_CALCULATED: 'DAILY_CALCULATED'
};
export const ReferrerType = {
    RESELLER: 'RESELLER',
    AGENT: 'AGENT',
    AFFILIATE: 'AFFILIATE'
};
export const CommissionStatus = {
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    PAID: 'PAID',
    CANCELLED: 'CANCELLED'
};
export const DebtType = {
    MORTGAGE: 'MORTGAGE',
    PERSONAL_LOAN: 'PERSONAL_LOAN',
    LEASING: 'LEASING',
    LINE_OF_CREDIT: 'LINE_OF_CREDIT',
    OTHER: 'OTHER'
};
export const InterestType = {
    FIXED: 'FIXED',
    VARIABLE: 'VARIABLE'
};
export const DscrStatus = {
    HEALTHY: 'HEALTHY',
    WARNING: 'WARNING',
    CRISIS: 'CRISIS',
    NO_DEBT: 'NO_DEBT'
};
export const AIServiceType = {
    CHAT_MAIN: 'CHAT_MAIN',
    CHAT_CLASSIFIER: 'CHAT_CLASSIFIER',
    CHAT_SUMMARY: 'CHAT_SUMMARY',
    CHAT_HELP_MIXED: 'CHAT_HELP_MIXED',
    EMBEDDING: 'EMBEDDING',
    CATEGORY_SINGLE: 'CATEGORY_SINGLE',
    CATEGORY_BULK: 'CATEGORY_BULK',
    EMBEDDING_CATEGORY: 'EMBEDDING_CATEGORY',
    SYSTEM_ADMIN: 'SYSTEM_ADMIN',
    SYSTEM_BACKGROUND: 'SYSTEM_BACKGROUND',
    SYSTEM_DOCUMENT_OCR: 'SYSTEM_DOCUMENT_OCR',
    SYSTEM_HELP_RAG_QUERY: 'SYSTEM_HELP_RAG_QUERY',
    SYSTEM_HELP_EMBEDDING: 'SYSTEM_HELP_EMBEDDING',
    SYSTEM_HELP_SUMMARY: 'SYSTEM_HELP_SUMMARY',
    SYSTEM_SUPPORT_DRAFT: 'SYSTEM_SUPPORT_DRAFT',
    SYSTEM_INFRASTRUCTURE: 'SYSTEM_INFRASTRUCTURE'
};
export const AIUsageSource = {
    ACTUAL: 'ACTUAL',
    ESTIMATED: 'ESTIMATED',
    RECONCILED: 'RECONCILED'
};
export const AIUsageStatus = {
    SUCCEEDED: 'SUCCEEDED',
    FAILED: 'FAILED',
    BLOCKED: 'BLOCKED'
};
export const AIUsageReservationStatus = {
    ACTIVE: 'ACTIVE',
    SETTLED: 'SETTLED',
    CANCELLED: 'CANCELLED',
    EXPIRED: 'EXPIRED'
};
export const AIReconciliationStatus = {
    RECONCILED: 'RECONCILED',
    PARTIAL: 'PARTIAL',
    FAILED: 'FAILED',
    SKIPPED: 'SKIPPED'
};
export const SyncType = {
    MANUAL: 'MANUAL',
    AUTOMATIC: 'AUTOMATIC'
};
export const SyncStatus = {
    RUNNING: 'RUNNING',
    COMPLETED: 'COMPLETED',
    ERROR: 'ERROR'
};
export const NotificationType = {
    SYNC_COMPLETED: 'SYNC_COMPLETED',
    BALANCE_ALERT: 'BALANCE_ALERT',
    DUE_DATE_REMINDER: 'DUE_DATE_REMINDER',
    OVERDUE_PAYMENT: 'OVERDUE_PAYMENT',
    USER_ACCEPTED_INVITATION: 'USER_ACCEPTED_INVITATION',
    SUBSCRIPTION_EXPIRING: 'SUBSCRIPTION_EXPIRING',
    SUBSCRIPTION_EXPIRED: 'SUBSCRIPTION_EXPIRED',
    SUBSCRIPTION_RENEWED: 'SUBSCRIPTION_RENEWED',
    SUBSCRIPTION_UPGRADED: 'SUBSCRIPTION_UPGRADED',
    SUBSCRIPTION_CANCELING: 'SUBSCRIPTION_CANCELING',
    SUBSCRIPTION_REACTIVATED: 'SUBSCRIPTION_REACTIVATED',
    PAYMENT_FAILED: 'PAYMENT_FAILED',
    SEPA_PAYMENT_FAILED: 'SEPA_PAYMENT_FAILED',
    SDI_INVOICE_QUARANTENA: 'SDI_INVOICE_QUARANTENA',
    SDI_INVOICE_ERROR: 'SDI_INVOICE_ERROR',
    SDI_INVOICE_ACCEPTED: 'SDI_INVOICE_ACCEPTED',
    AI_AUTO_CATEGORIZATION: 'AI_AUTO_CATEGORIZATION',
    CONSENT_EXPIRING: 'CONSENT_EXPIRING',
    CONSENT_EXPIRED: 'CONSENT_EXPIRED',
    CASSETTO_CREDENTIALS_EXPIRING: 'CASSETTO_CREDENTIALS_EXPIRING',
    CASSETTO_CREDENTIALS_EXPIRED: 'CASSETTO_CREDENTIALS_EXPIRED',
    ACUBE_F24_REVIEW_REQUIRED: 'ACUBE_F24_REVIEW_REQUIRED',
    REVISO_CREDENTIALS_EXPIRING: 'REVISO_CREDENTIALS_EXPIRING',
    REVISO_CREDENTIALS_EXPIRED: 'REVISO_CREDENTIALS_EXPIRED',
    INTEGRATION_AUTH_EXPIRED: 'INTEGRATION_AUTH_EXPIRED',
    ADMIN_ANNOUNCEMENT: 'ADMIN_ANNOUNCEMENT',
    MCP_CONNECTION: 'MCP_CONNECTION',
    SUPPORT_TICKET_REPLIED: 'SUPPORT_TICKET_REPLIED',
    SUPPORT_TICKET_STATUS_CHANGED: 'SUPPORT_TICKET_STATUS_CHANGED',
    MACHINE_CHECK_DUE: 'MACHINE_CHECK_DUE',
    MACHINE_CHECK_OVERDUE: 'MACHINE_CHECK_OVERDUE'
};
export const JobExecutionStatus = {
    PENDING: 'PENDING',
    ACTIVE: 'ACTIVE',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
    DELAYED: 'DELAYED',
    RETRIED: 'RETRIED'
};
export const ErrorLogLevel = {
    WARN: 'WARN',
    ERROR: 'ERROR',
    CRITICAL: 'CRITICAL'
};
export const InternalTransferMatchType = {
    SEMANTIC: 'SEMANTIC',
    MATH: 'MATH',
    RULE: 'RULE',
    COMBINED: 'COMBINED'
};
export const SuggestionStatus = {
    PENDING: 'PENDING',
    ACCEPTED: 'ACCEPTED',
    DISMISSED: 'DISMISSED',
    EXPIRED: 'EXPIRED'
};
export const AccountTransferStatus = {
    PENDING_COUNTERPART: 'PENDING_COUNTERPART',
    PROPOSED: 'PROPOSED',
    CONFIRMED: 'CONFIRMED',
    BROKEN: 'BROKEN',
    CLOSED_WITHOUT_COUNTERPART: 'CLOSED_WITHOUT_COUNTERPART'
};
export const AccountTransferMatchMethod = {
    MANUAL: 'MANUAL',
    AMOUNT_DATE: 'AMOUNT_DATE',
    DESCRIPTION: 'DESCRIPTION',
    IBAN: 'IBAN',
    COMBINED: 'COMBINED',
    CURRENCY_CONVERSION: 'CURRENCY_CONVERSION'
};
export const AccountTransferEventType = {
    CREATED: 'CREATED',
    PROPOSED: 'PROPOSED',
    CONFIRMED: 'CONFIRMED',
    NOTE_UPDATED: 'NOTE_UPDATED',
    UNLINKED: 'UNLINKED',
    BROKEN: 'BROKEN',
    RESTORED: 'RESTORED',
    CLOSED: 'CLOSED',
    REOPENED: 'REOPENED'
};
export const DocumentReferenceType = {
    FATTURA_PRINCIPALE: 'FATTURA_PRINCIPALE',
    FATTURA_COLLEGATA: 'FATTURA_COLLEGATA',
    ORDER_REFERENCE: 'ORDER_REFERENCE',
    DDT_REFERENCE: 'DDT_REFERENCE',
    CONTRACT_REFERENCE: 'CONTRACT_REFERENCE',
    CONVENTION_REFERENCE: 'CONVENTION_REFERENCE',
    RECEPTION_REFERENCE: 'RECEPTION_REFERENCE',
    INVOICE_REFERENCE: 'INVOICE_REFERENCE',
    TRANSFORMED_FROM: 'TRANSFORMED_FROM',
    TRANSFORMED_TO: 'TRANSFORMED_TO'
};
export const PaymentStatus = {
    PENDING: 'PENDING',
    CONFIRMED: 'CONFIRMED',
    FAILED: 'FAILED'
};
export const AcubePaymentDirection = {
    INBOUND: 'INBOUND',
    OUTBOUND: 'OUTBOUND'
};
export const AcubePaymentSource = {
    WEBHOOK: 'WEBHOOK',
    SYNC: 'SYNC',
    BACKFILL: 'BACKFILL'
};
export const SepaPaymentAdminEventType = {
    STATUS_CHANGED: 'STATUS_CHANGED',
    AUTOMATION_RESUMED: 'AUTOMATION_RESUMED',
    REMOTE_SYNCED: 'REMOTE_SYNCED',
    RESET: 'RESET',
    ORPHAN_REVIEWED: 'ORPHAN_REVIEWED'
};
export const TenantDeletionReason = {
    USER_REQUEST: 'USER_REQUEST',
    BACKOFFICE: 'BACKOFFICE',
    SUBSCRIPTION_ENDED: 'SUBSCRIPTION_ENDED',
    SUBSCRIPTION_NOT_RENEWED: 'SUBSCRIPTION_NOT_RENEWED'
};
export const SubscriptionEmailType = {
    EXPIRING: 'EXPIRING',
    EXPIRED: 'EXPIRED',
    RENEWAL_REMINDER: 'RENEWAL_REMINDER',
    DEMO_EXPIRING: 'DEMO_EXPIRING',
    DEMO_LAST_DAY: 'DEMO_LAST_DAY',
    DEMO_EXPIRED: 'DEMO_EXPIRED',
    DELETION_SCHEDULED: 'DELETION_SCHEDULED',
    PAYMENT_DUE_30: 'PAYMENT_DUE_30',
    PAYMENT_DUE_15: 'PAYMENT_DUE_15',
    PAYMENT_DUE_7: 'PAYMENT_DUE_7',
    PAYMENT_DUE_1: 'PAYMENT_DUE_1',
    PAYMENT_DUE_TODAY: 'PAYMENT_DUE_TODAY',
    PAYMENT_OVERDUE: 'PAYMENT_OVERDUE',
    NOT_RENEWING_30: 'NOT_RENEWING_30',
    NOT_RENEWING_15: 'NOT_RENEWING_15',
    NOT_RENEWING_7: 'NOT_RENEWING_7',
    NOT_RENEWING_1: 'NOT_RENEWING_1',
    INSTALLMENT_DUE_15: 'INSTALLMENT_DUE_15',
    INSTALLMENT_DUE_7: 'INSTALLMENT_DUE_7',
    INSTALLMENT_DUE_1: 'INSTALLMENT_DUE_1'
};
export const AdminNotificationStatus = {
    DRAFT: 'DRAFT',
    SCHEDULED: 'SCHEDULED',
    SENT: 'SENT',
    CANCELLED: 'CANCELLED'
};
export const RibaScheduleStatus = {
    NONE: 'NONE',
    PRESENTED: 'PRESENTED',
    SETTLED: 'SETTLED',
    UNPAID: 'UNPAID'
};
export const DistintaRibaStatus = {
    DRAFT: 'DRAFT',
    PRESENTED: 'PRESENTED',
    APPROVED: 'APPROVED',
    PARTIALLY_SETTLED: 'PARTIALLY_SETTLED',
    SETTLED: 'SETTLED',
    PARTIALLY_UNPAID: 'PARTIALLY_UNPAID',
    UNPAID: 'UNPAID',
    CANCELLED: 'CANCELLED'
};
export const DistintaRibaType = {
    RIBA: 'RIBA',
    INVOICE_ADVANCE: 'INVOICE_ADVANCE'
};
export const DistintaAdvanceRequestMode = {
    NONE: 'NONE',
    SBF_REQUESTED: 'SBF_REQUESTED'
};
export const InvoiceAdvanceStatus = {
    DISBURSED: 'DISBURSED',
    SETTLED: 'SETTLED',
    INSOLUTO: 'INSOLUTO'
};
export const ServiceUsageType = {
    AI_CHAT_MESSAGE: 'AI_CHAT_MESSAGE',
    AI_AUTO_CATEGORIZATION: 'AI_AUTO_CATEGORIZATION',
    AI_CATEGORY_SUGGESTION: 'AI_CATEGORY_SUGGESTION',
    AI_GIROCONTI_APPLY: 'AI_GIROCONTI_APPLY',
    AI_RECONCILIATION_RUN: 'AI_RECONCILIATION_RUN',
    DOCUMENT_OCR: 'DOCUMENT_OCR',
    SEPA_PAYMENT_SEND: 'SEPA_PAYMENT_SEND',
    SEPA_INSTANT_PAYMENT_SEND: 'SEPA_INSTANT_PAYMENT_SEND',
    SEPA_PAYMENT_RECEIVE: 'SEPA_PAYMENT_RECEIVE',
    SEPA_INSTANT_PAYMENT_RECEIVE: 'SEPA_INSTANT_PAYMENT_RECEIVE',
    BANK_CSV_IMPORT: 'BANK_CSV_IMPORT',
    CARD_PDF_IMPORT: 'CARD_PDF_IMPORT',
    BANK_PDF_IMPORT: 'BANK_PDF_IMPORT',
    FATTURAPA_XML_IMPORT: 'FATTURAPA_XML_IMPORT',
    PAYROLL_CSV_IMPORT: 'PAYROLL_CSV_IMPORT',
    EXPORT_CSV: 'EXPORT_CSV',
    EXPORT_XLSX: 'EXPORT_XLSX',
    EXPORT_PDF: 'EXPORT_PDF',
    EXPORT_FATTURAPA_XML: 'EXPORT_FATTURAPA_XML',
    DISTINTA_RIBA_CREATE: 'DISTINTA_RIBA_CREATE',
    RIBA_REPRESENT: 'RIBA_REPRESENT',
    INVOICE_ADVANCE_CREATE: 'INVOICE_ADVANCE_CREATE',
    INVOICE_ADVANCE_SETTLE: 'INVOICE_ADVANCE_SETTLE',
    RECONCILIATION_AUTO_MATCH_FORECAST: 'RECONCILIATION_AUTO_MATCH_FORECAST',
    RECONCILIATION_AUTO_MATCH_CASH: 'RECONCILIATION_AUTO_MATCH_CASH',
    RECONCILIATION_AUTO_MATCH_SCHEDULE: 'RECONCILIATION_AUTO_MATCH_SCHEDULE',
    RECONCILIATION_MANUAL_LINK: 'RECONCILIATION_MANUAL_LINK',
    FOREIGN_INVOICE_ANALYSIS: 'FOREIGN_INVOICE_ANALYSIS',
    FOREIGN_INVOICE_DRAFT_CREATE: 'FOREIGN_INVOICE_DRAFT_CREATE',
    DSCR_SNAPSHOT_CREATE: 'DSCR_SNAPSHOT_CREATE',
    FORECAST_SCENARIO_CLONE: 'FORECAST_SCENARIO_CLONE',
    BANK_ACCOUNT_CONNECT: 'BANK_ACCOUNT_CONNECT'
};
export const AcubeJobType = {
    INVOICE_DOWNLOAD: 'INVOICE_DOWNLOAD',
    INVOICE_REPORT_DOWNLOAD: 'INVOICE_REPORT_DOWNLOAD',
    INVOICE_ZIP_DOWNLOAD: 'INVOICE_ZIP_DOWNLOAD',
    F24_DOWNLOAD: 'F24_DOWNLOAD'
};
export const AcubeJobStatus = {
    READY: 'READY',
    STARTED: 'STARTED',
    COMPLETED: 'COMPLETED',
    ERROR: 'ERROR'
};
export const InvoicingMode = {
    NONE: 'NONE',
    CASSETTO_FISCALE: 'CASSETTO_FISCALE',
    ACUBE_SDI: 'ACUBE_SDI'
};
export const TaxSubjectType = {
    UNKNOWN: 'UNKNOWN',
    INDIVIDUAL: 'INDIVIDUAL',
    LEGAL_ENTITY: 'LEGAL_ENTITY'
};
export const AcubeDelegationState = {
    NONE: 'NONE',
    PENDING: 'PENDING',
    ACTIVE: 'ACTIVE'
};
export const DocumentElectronicEventType = {
    XML_GENERATED: 'XML_GENERATED',
    XML_GENERATION_FAILED: 'XML_GENERATION_FAILED',
    SDI_SEND_REQUESTED: 'SDI_SEND_REQUESTED',
    SDI_SENT: 'SDI_SENT',
    SDI_ACCEPTED: 'SDI_ACCEPTED',
    SDI_QUARANTENA: 'SDI_QUARANTENA',
    SDI_REJECTED: 'SDI_REJECTED',
    SDI_NOT_DELIVERED: 'SDI_NOT_DELIVERED',
    SDI_UNLOCKED: 'SDI_UNLOCKED',
    SDI_RECOVERY_TIMEOUT: 'SDI_RECOVERY_TIMEOUT',
    EMAIL_SENT: 'EMAIL_SENT',
    EMAIL_FAILED: 'EMAIL_FAILED',
    REMINDER_SENT: 'REMINDER_SENT'
};
export const AcubeMarking = {
    NOT_SENT: 'NOT_SENT',
    GENERATING: 'GENERATING',
    WAITING: 'WAITING',
    SENT: 'SENT',
    ACCEPTED: 'ACCEPTED',
    QUARANTENA: 'QUARANTENA',
    INVOICE_ERROR: 'INVOICE_ERROR',
    REJECTED: 'REJECTED'
};
export const AcubeF24FormStatus = {
    QUEUED: 'QUEUED',
    READY: 'READY',
    ERROR: 'ERROR'
};
export const AcubeF24ReviewStatus = {
    PENDING_REVIEW: 'PENDING_REVIEW',
    AUTO_LINKED: 'AUTO_LINKED',
    IMPORTED: 'IMPORTED'
};
export const AcubeF24MatchKind = {
    DELEGATION: 'DELEGATION',
    DOCUMENT: 'DOCUMENT',
    NONE: 'NONE'
};
export const McpTokenKind = {
    ACCESS: 'ACCESS',
    REFRESH: 'REFRESH'
};
export const McpTokenStatus = {
    ACTIVE: 'ACTIVE',
    REVOKED: 'REVOKED',
    EXPIRED: 'EXPIRED'
};
export const McpAuditEventType = {
    PRODUCT_ACCESS_CHANGED: 'PRODUCT_ACCESS_CHANGED',
    TOKEN_ISSUED: 'TOKEN_ISSUED',
    TOKEN_ROTATED: 'TOKEN_ROTATED',
    TOKEN_REVOKED: 'TOKEN_REVOKED',
    CONSENT_GRANTED: 'CONSENT_GRANTED',
    CONSENT_DENIED: 'CONSENT_DENIED',
    TOOL_CALL: 'TOOL_CALL',
    CLIENT_VERIFIED: 'CLIENT_VERIFIED',
    CLIENT_DEACTIVATED: 'CLIENT_DEACTIVATED'
};
export const McpAuditOutcome = {
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
    RATE_LIMITED: 'RATE_LIMITED'
};
export const TenantMembershipAuditEventType = {
    INVITATION_CREATED: 'INVITATION_CREATED',
    INVITATION_REISSUED: 'INVITATION_REISSUED',
    INVITATION_REVOKED: 'INVITATION_REVOKED',
    INVITATION_ACCEPTED: 'INVITATION_ACCEPTED',
    MEMBERSHIP_UPDATED: 'MEMBERSHIP_UPDATED',
    MEMBERSHIP_REMOVED: 'MEMBERSHIP_REMOVED',
    OWNER_ASSIGNED: 'OWNER_ASSIGNED',
    OWNER_REMOVED: 'OWNER_REMOVED',
    IMPERSONATION_STARTED: 'IMPERSONATION_STARTED',
    PERMISSION_PREVIEW_STARTED: 'PERMISSION_PREVIEW_STARTED',
    PERMISSION_PREVIEW_ENDED: 'PERMISSION_PREVIEW_ENDED'
};
export const PublicApiKeyStatus = {
    ACTIVE: 'ACTIVE',
    REVOKED: 'REVOKED',
    EXPIRED: 'EXPIRED'
};
export const PublicApiIdempotencyStatus = {
    PROCESSING: 'PROCESSING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED'
};
export const PublicApiAuditOutcome = {
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
    RATE_LIMITED: 'RATE_LIMITED'
};
export const PublicApiEventAction = {
    CREATED: 'CREATED',
    UPDATED: 'UPDATED',
    DELETED: 'DELETED',
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    SUBMITTED: 'SUBMITTED',
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED',
    DELIVERY_FAILED: 'DELIVERY_FAILED',
    APPROVED: 'APPROVED',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
    CONFIRMED: 'CONFIRMED',
    SETTLED: 'SETTLED',
    RECONCILED: 'RECONCILED',
    ADJUSTED: 'ADJUSTED',
    TRANSFERRED: 'TRANSFERRED',
    CLOSED: 'CLOSED',
    GENERATED: 'GENERATED',
    FAILED: 'FAILED'
};
export const PublicApiJobStatus = {
    PENDING: 'PENDING',
    RUNNING: 'RUNNING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
    CANCELLED: 'CANCELLED'
};
export const PublicApiPaymentExecutionStatus = {
    PENDING: 'PENDING',
    SUBMITTED: 'SUBMITTED',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED'
};
export const PublicApiWebhookStatus = {
    ACTIVE: 'ACTIVE',
    DISABLED: 'DISABLED'
};
export const PublicApiWebhookDeliveryStatus = {
    PENDING: 'PENDING',
    DELIVERED: 'DELIVERED',
    FAILED: 'FAILED'
};
export const CommessaStatus = {
    ACTIVE: 'ACTIVE',
    CLOSED: 'CLOSED'
};
export const ErpPushState = {
    NONE: 'NONE',
    PENDING: 'PENDING',
    DRAFT_CREATED: 'DRAFT_CREATED',
    BOOKED: 'BOOKED',
    COMPLETED: 'COMPLETED',
    ORPHAN: 'ORPHAN',
    BLOCKED: 'BLOCKED'
};
export const ErpDivergenceType = {
    LOCAL_REVERTED_AFTER_PUSH: 'LOCAL_REVERTED_AFTER_PUSH',
    REMOTE_REVERTED_AFTER_PUSH: 'REMOTE_REVERTED_AFTER_PUSH',
    REMOTE_REVERTED_INBOUND: 'REMOTE_REVERTED_INBOUND',
    ORPHAN_VOUCHER: 'ORPHAN_VOUCHER',
    AMOUNT_MISMATCH: 'AMOUNT_MISMATCH',
    UNMATCHED_INVOICE: 'UNMATCHED_INVOICE',
    AMBIGUOUS_MATCH: 'AMBIGUOUS_MATCH',
    REMOTE_MISSING: 'REMOTE_MISSING',
    PARTIAL_STATE_CONFLICT: 'PARTIAL_STATE_CONFLICT',
    PUSH_ACCOUNT_UNMAPPED: 'PUSH_ACCOUNT_UNMAPPED',
    PUSH_ACCOUNT_SPLIT_MISMATCH: 'PUSH_ACCOUNT_SPLIT_MISMATCH',
    PUSH_NO_MOVEMENT: 'PUSH_NO_MOVEMENT',
    PUSH_CURRENCY_UNSUPPORTED: 'PUSH_CURRENCY_UNSUPPORTED',
    PUSH_DOC_KIND_MISMATCH: 'PUSH_DOC_KIND_MISMATCH'
};
export const ErpDivergenceStatus = {
    OPEN: 'OPEN',
    ACKNOWLEDGED: 'ACKNOWLEDGED',
    RESOLVED: 'RESOLVED'
};
export const ErpSyncRunKind = {
    SYNC: 'SYNC',
    PUSH: 'PUSH'
};
export const SupportTicketType = {
    ASSISTANCE: 'ASSISTANCE',
    TRAINING: 'TRAINING',
    COMMERCIAL: 'COMMERCIAL'
};
export const SupportTicketCategory = {
    ELECTRONIC_INVOICING: 'ELECTRONIC_INVOICING',
    BANKING_RECONCILIATION: 'BANKING_RECONCILIATION',
    FORECAST_DSCR: 'FORECAST_DSCR',
    PAYMENTS: 'PAYMENTS',
    DOCUMENTS: 'DOCUMENTS',
    WAREHOUSE_PRODUCTS: 'WAREHOUSE_PRODUCTS',
    COMMESSE: 'COMMESSE',
    INTEGRATIONS: 'INTEGRATIONS',
    AI_ASSISTANT: 'AI_ASSISTANT',
    BILLING_SUBSCRIPTION: 'BILLING_SUBSCRIPTION',
    ACCOUNT_PERMISSIONS: 'ACCOUNT_PERMISSIONS',
    OTHER: 'OTHER'
};
export const SupportTicketStatus = {
    OPEN: 'OPEN',
    IN_PROGRESS: 'IN_PROGRESS',
    WAITING_CUSTOMER: 'WAITING_CUSTOMER',
    RESOLVED: 'RESOLVED',
    CLOSED: 'CLOSED'
};
export const SupportTicketPriority = {
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    HIGH: 'HIGH',
    URGENT: 'URGENT'
};
export const SupportTicketAuthorSide = {
    CUSTOMER: 'CUSTOMER',
    OPERATOR: 'OPERATOR',
    SYSTEM: 'SYSTEM'
};
export const SupportTicketEventType = {
    CREATED: 'CREATED',
    MESSAGE_ADDED: 'MESSAGE_ADDED',
    INTERNAL_NOTE_ADDED: 'INTERNAL_NOTE_ADDED',
    STATUS_CHANGED: 'STATUS_CHANGED',
    ASSIGNED: 'ASSIGNED',
    UNASSIGNED: 'UNASSIGNED',
    PRIORITY_CHANGED: 'PRIORITY_CHANGED',
    CATEGORY_CHANGED: 'CATEGORY_CHANGED',
    TYPE_CHANGED: 'TYPE_CHANGED',
    FIRST_RESPONSE: 'FIRST_RESPONSE',
    REOPENED: 'REOPENED',
    ATTACHMENT_ADDED: 'ATTACHMENT_ADDED',
    ATTACHMENT_UPLOAD_FAILED: 'ATTACHMENT_UPLOAD_FAILED',
    AUTO_CLOSED: 'AUTO_CLOSED'
};
export const IntentDeclarationKind = {
    SINGLE_OPERATION: 'SINGLE_OPERATION',
    UP_TO_AMOUNT: 'UP_TO_AMOUNT'
};
export const IntentDeclarationStatus = {
    ACTIVE: 'ACTIVE',
    REVOKED: 'REVOKED',
    SUPERSEDED: 'SUPERSEDED'
};
export const PayrollExtraPay = {
    THIRTEENTH: 'THIRTEENTH',
    FOURTEENTH: 'FOURTEENTH'
};
export const F24DelegationType = {
    ORDIN: 'ORDIN',
    SEMPL: 'SEMPL',
    ELIDE: 'ELIDE'
};
export const F24DelegationStatus = {
    DIAGNOSTICA_OK: 'DIAGNOSTICA_OK',
    DIAGNOSTICA_KO: 'DIAGNOSTICA_KO',
    CONSOLIDATA: 'CONSOLIDATA',
    SCADUTA: 'SCADUTA',
    CANCELLATA: 'CANCELLATA',
    TRANSAZIONE_KO: 'TRANSAZIONE_KO',
    IN_CARICO: 'IN_CARICO',
    ERRORE: 'ERRORE',
    PAGATA: 'PAGATA'
};
export const HotelReservationStatus = {
    ACTIVE: 'ACTIVE',
    CANCELLED: 'CANCELLED'
};
export const InfrastructureCostUnit = {
    INVOICE: 'INVOICE',
    BANK_CONNECTION: 'BANK_CONNECTION',
    TAX_DRAWER_CONNECTION: 'TAX_DRAWER_CONNECTION',
    ESDI_CONNECTION: 'ESDI_CONNECTION',
    OTHER: 'OTHER'
};
export const InfrastructureBillingFrequency = {
    USAGE: 'USAGE',
    MONTHLY: 'MONTHLY',
    QUARTERLY: 'QUARTERLY',
    ANNUAL: 'ANNUAL',
    ONE_OFF: 'ONE_OFF'
};
export const IntegrationProvider = {
    JET_HR: 'JET_HR',
    REVOLUT: 'REVOLUT',
    STRIPE: 'STRIPE',
    PAYPAL: 'PAYPAL',
    FATTURE_IN_CLOUD: 'FATTURE_IN_CLOUD',
    REVISO: 'REVISO',
    COMPUTER_GROSS: 'COMPUTER_GROSS',
    GENYA: 'GENYA'
};
export const IntegrationStatus = {
    PENDING: 'PENDING',
    CONNECTED: 'CONNECTED',
    DISCONNECTED: 'DISCONNECTED',
    ERROR: 'ERROR'
};
export const KnowledgeSourceCode = {
    HELP_MARKDOWN: 'HELP_MARKDOWN',
    HELP_FAQ_DERIVED: 'HELP_FAQ_DERIVED',
    SUPPORT_PLAYBOOK: 'SUPPORT_PLAYBOOK',
    RELEASE_NOTES: 'RELEASE_NOTES'
};
export const KnowledgeDocumentType = {
    MANUAL_SECTION: 'MANUAL_SECTION',
    MANUAL_SUBSECTION: 'MANUAL_SUBSECTION',
    TASK: 'TASK',
    TROUBLESHOOTING: 'TROUBLESHOOTING',
    FAQ: 'FAQ',
    SUPPORT_POLICY: 'SUPPORT_POLICY'
};
export const KnowledgeChunkType = {
    SUMMARY: 'SUMMARY',
    SECTION: 'SECTION',
    FAQ: 'FAQ',
    SUPPORT: 'SUPPORT'
};
export const KnowledgeDocumentStatus = {
    DRAFT: 'DRAFT',
    PUBLISHED: 'PUBLISHED',
    ARCHIVED: 'ARCHIVED'
};
export const KnowledgeIngestionStatus = {
    PENDING: 'PENDING',
    RUNNING: 'RUNNING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED'
};
export const PaymentTermType = {
    SINGLE: 'SINGLE',
    MULTIPLE: 'MULTIPLE'
};
export const PriceListRuleType = {
    CATEGORY: 'CATEGORY',
    COMPANY: 'COMPANY',
    PRODUCT: 'PRODUCT',
    GLOBAL: 'GLOBAL'
};
export const PriceListRuleModifierType = {
    PERCENT_DISCOUNT: 'PERCENT_DISCOUNT',
    FIXED_DISCOUNT: 'FIXED_DISCOUNT',
    PERCENT_MARKUP: 'PERCENT_MARKUP',
    FIXED_PRICE: 'FIXED_PRICE'
};
export const ProductReleaseStatus = {
    PUBLISHING: 'PUBLISHING',
    PUBLISHED: 'PUBLISHED',
    FAILED: 'FAILED',
    ROLLED_BACK: 'ROLLED_BACK'
};
export const ProductReleaseSlackStatus = {
    PENDING: 'PENDING',
    SENDING: 'SENDING',
    SENT: 'SENT',
    SKIPPED: 'SKIPPED',
    FAILED: 'FAILED'
};
export const ProductChangeType = {
    FEATURE: 'FEATURE',
    FIX: 'FIX',
    IMPROVEMENT: 'IMPROVEMENT',
    BREAKING: 'BREAKING'
};
export const ProductChangeVisibility = {
    CUSTOMER: 'CUSTOMER',
    INTERNAL: 'INTERNAL'
};
export const ProductType = {
    PRODUCT_STOCKED: 'PRODUCT_STOCKED',
    PRODUCT_UNSTOCKED: 'PRODUCT_UNSTOCKED',
    SERVICE: 'SERVICE',
    RECURRING_SERVICE: 'RECURRING_SERVICE',
    LABOR: 'LABOR',
    ACCESSORY_CHARGE: 'ACCESSORY_CHARGE',
    OTHER: 'OTHER'
};
export const ServiceContractStatus = {
    DRAFT: 'DRAFT',
    ACTIVE: 'ACTIVE',
    CANCELLATION_SCHEDULED: 'CANCELLATION_SCHEDULED',
    TERMINATED: 'TERMINATED'
};
export const ServiceContractPeriodStatus = {
    OPEN: 'OPEN',
    CLOSED: 'CLOSED'
};
export const ServiceContractChangeKind = {
    ADDITION: 'ADDITION',
    REDUCTION: 'REDUCTION'
};
export const ServiceContractChangeStatus = {
    SCHEDULED: 'SCHEDULED',
    CANCELLED: 'CANCELLED'
};
export const BillableChargeSource = {
    ACTIVATION: 'ACTIVATION',
    LINE_ADDITION: 'LINE_ADDITION',
    RENEWAL: 'RENEWAL',
    WORK_LABOR: 'WORK_LABOR',
    WORK_MATERIAL: 'WORK_MATERIAL'
};
export const BillableChargeStatus = {
    OPEN: 'OPEN',
    INVOICED: 'INVOICED',
    VOIDED: 'VOIDED'
};
export const ServiceContractEventType = {
    CREATED: 'CREATED',
    UPDATED: 'UPDATED',
    ACTIVATED: 'ACTIVATED',
    CHANGE_ADDED: 'CHANGE_ADDED',
    CHANGE_CANCELLED: 'CHANGE_CANCELLED',
    RENEWED: 'RENEWED',
    CANCELLATION_SCHEDULED: 'CANCELLATION_SCHEDULED',
    CANCELLATION_REVOKED: 'CANCELLATION_REVOKED',
    TERMINATED: 'TERMINATED',
    PERIOD_COMMESSA_CHANGED: 'PERIOD_COMMESSA_CHANGED'
};
export const StockMovementType = {
    DDT_OUT: 'DDT_OUT',
    DDT_IN: 'DDT_IN',
    INVOICE_OUT: 'INVOICE_OUT',
    INVOICE_IN: 'INVOICE_IN',
    ADJUSTMENT: 'ADJUSTMENT',
    TRANSFER_OUT: 'TRANSFER_OUT',
    TRANSFER_IN: 'TRANSFER_IN',
    INVENTORY_COUNT: 'INVENTORY_COUNT',
    RETURN_IN: 'RETURN_IN',
    RETURN_OUT: 'RETURN_OUT',
    REVERSAL: 'REVERSAL'
};
export const StockMovementDirection = {
    IN: 'IN',
    OUT: 'OUT'
};
export const InventorySessionStatus = {
    DRAFT: 'DRAFT',
    COUNTING: 'COUNTING',
    CLOSED: 'CLOSED',
    CANCELLED: 'CANCELLED'
};
export const TenantHealthSeverity = {
    OK: 'OK',
    WARNING: 'WARNING',
    CRITICAL: 'CRITICAL'
};
export const SessionAuthMethod = {
    PASSWORD: 'PASSWORD',
    DEVICE: 'DEVICE',
    WEB_LOGIN_APPROVAL: 'WEB_LOGIN_APPROVAL',
    PASSKEY: 'PASSKEY',
    IMPERSONATION: 'IMPERSONATION'
};
export const TrustedDevicePlatform = {
    IOS: 'IOS',
    ANDROID: 'ANDROID'
};
export const TrustedDeviceRevokeReason = {
    USER: 'USER',
    PASSWORD_RESET: 'PASSWORD_RESET',
    LOGOUT_ALL: 'LOGOUT_ALL',
    SECRET_REUSE: 'SECRET_REUSE',
    BIOMETRIC_DISABLED: 'BIOMETRIC_DISABLED',
    REPLACED: 'REPLACED'
};
export const WebLoginRequestStatus = {
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    DENIED: 'DENIED',
    EXPIRED: 'EXPIRED',
    CONSUMED: 'CONSUMED'
};
export const WebAuthnChallengePurpose = {
    REGISTRATION: 'REGISTRATION',
    AUTHENTICATION: 'AUTHENTICATION'
};
export const ServiceTariffKind = {
    REMOTE: 'REMOTE',
    ONSITE: 'ONSITE',
    LAB: 'LAB'
};
export const WorkReportStatus = {
    DRAFT: 'DRAFT',
    SUBMITTED: 'SUBMITTED',
    APPROVED: 'APPROVED',
    CANCELLED: 'CANCELLED'
};
export const WorkReportTimeMode = {
    RANGE: 'RANGE',
    DURATION: 'DURATION'
};
export const WorkReportTreatment = {
    BILLABLE: 'BILLABLE',
    INCLUDED: 'INCLUDED',
    NOT_BILLABLE: 'NOT_BILLABLE'
};
export const WorkReportLineKind = {
    MATERIAL: 'MATERIAL',
    LICENSE: 'LICENSE',
    OTHER: 'OTHER'
};
export const WorkReportEventType = {
    CREATED: 'CREATED',
    UPDATED: 'UPDATED',
    SUBMITTED: 'SUBMITTED',
    APPROVED: 'APPROVED',
    RECTIFIED: 'RECTIFIED',
    CANCELLED: 'CANCELLED',
    DELETED: 'DELETED',
    PUBLISHED: 'PUBLISHED',
    UNPUBLISHED: 'UNPUBLISHED',
    SENT_TO_CUSTOMER: 'SENT_TO_CUSTOMER',
    SHARE_LINK_OPENED: 'SHARE_LINK_OPENED',
    SHARE_LINK_REVOKED: 'SHARE_LINK_REVOKED',
    AUTO_PUBLISH_FAILED: 'AUTO_PUBLISH_FAILED'
};
//# sourceMappingURL=enums.js.map